import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=098fc9c2&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=098fc9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098fc9c2",
  null
  
)

export default component.exports